import { InputGroup } from '@/components/InputGroup'
import { RadioGroup } from '@/containers/forms/RadioGroup'
import { DisableReasonValue } from '@/dtos/PoleasImport'
import { Box, Button, Flex, FormControl, FormLabel, Radio, Text, Textarea } from '@chakra-ui/react'
import { FormProvider, useForm, yupResolver } from 'BrokerTsLib/src/rhf'
import { nameof } from 'ts-simple-nameof'
import * as yup from 'yup'

export const schema = yup.object().shape(
  {
    reason: yup.number().required('Vyberte důvod'),
    reasonText: yup.string().when([nameof<BlockClientAccessFormValues>(x => x.reason)], {
      is: (reason: number) => reason == DisableReasonValue.Other,
      then: () => yup.string().nullable().required('Vyplňte důvod zablokování'),
      otherwise: () => yup.string().nullable()
    })
  }
) as any

interface BlockClientAccessFormProps {
  userText: string
  onSubmit: (values: BlockClientAccessFormValues) => Promise<any>
  onCancel: () => void
}

export interface BlockClientAccessFormValues {
  reason: DisableReasonValue
  reasonText?: string
}


export const BlockClientAccessForm = ({ userText, onSubmit, onCancel }: BlockClientAccessFormProps) => {

  const methods = useForm<BlockClientAccessFormValues>({
    defaultValues: {
      reason: 1,
      reasonText: ''
    },
    resolver: yupResolver(schema),
    mode: 'onBlur'
  })

  const { handleSubmit, register, setValue, watch, formState } = methods
  const { errors, isSubmitting } = formState

  const handleFormSubmit = (values: BlockClientAccessFormValues) => {
    return onSubmit(values)
  }

  const reasonValue = watch('reason')

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Box sx={{ display: 'grid', gap: 4, justifyItems: 'stretch' }}>
          <FormControl>
            <FormLabel>Nabídka pro uživatele</FormLabel>

            <Text>{userText}</Text>
          </FormControl>

          <FormControl>
            <FormLabel htmlFor="vin">Důvod zablokování</FormLabel>

            <RadioGroup
              {...register('reason')}
              ref={null}
              onChange={e => setValue('reason', parseInt(e) as DisableReasonValue)}
              value={reasonValue.toString()}
              stackProps={{
                direction: {
                  lg: 'column',
                },
                gap: 2
              }}
            >

              <Radio value={DisableReasonValue.ClientDontWantToBeContacted.toString()}>
                Klient si nepřeje být kontaktovaný
              </Radio>
              <Radio value={DisableReasonValue.Other.toString()}>
                Jiný
              </Radio>
            </RadioGroup>
          </FormControl>

          <FormControl isInvalid={!!errors.reasonText?.message}>
            <FormLabel htmlFor="registration">Popis důvodu zablokování</FormLabel>

            <InputGroup
              as={Textarea}
              errors={errors.reasonText}
              {...register('reasonText')}
            />
          </FormControl>

          <Flex mt={4} justifyContent='center' gap={4}>

            <Button
              type="submit"
              variant="solid"
              colorScheme="primary"
              isLoading={isSubmitting}
              disabled={isSubmitting}
            >
              Uložit
            </Button>

            <Button
              variant="solid"
              colorScheme="gray"
              onClick={onCancel}
            >
              Zrušit
            </Button>

          </Flex>
        </Box>
      </form>
    </FormProvider>
  )
}  